<script setup>
import moment from 'moment';
import { computed, ref } from 'vue';

const props = defineProps({
	params: {
		type: Object,
		required: true,
	}
})

function formatDate(val){
	//extract UTC time from default Xero format - not in use, we are carbon parsing dates server side
	// const time =  val.split('(').pop().split('+')[0]
	// return moment(parseInt(time)).format("DD MMM YY")
	return moment(val).format("DD MMM YYYY")
} 

const dateFormatted = computed(() => formatDate(props.params.data.DueDate))

const overDue = computed(() => {
	if (props.params.data.Status !== 'AUTHORISED') {
		return
	}
	const dueDate = new moment(props.params.data.DueDate);
	const today = new moment();
	
	if (dueDate < today) return true
	else return false
})

</script>


<template>
	<div v-if="overDue" class="relative h-[100%]" >
		<div class="">{{dateFormatted}}</div>
		<div class= "absolute bottom-[2px] right-[2px]  leading-4  bg-Red text-white text-[10px] px-2 py-0 rounded-md ">OVERDUE</div>
	</div>
	<p v-else class=" ">{{dateFormatted}}</p>
</template>